import { gql } from "@apollo/client";

const CollisionQuery = gql`
  query Edits {
    allEditCollisions {
      nodes {
        conEditDate
        conEditId
        conEditor
        conIsActive
        conKeepEdit
        conLatitude
        conLongitude
        conUrl
        editDate
        editId
        editor
        isActive
        keepEdit
        latitude
        longitude
        url
      }
      totalCount
    }
  }
`;

const hash = "a0bb1ad184665f845c61cde7ab74284ea58c8cddb8f75cb6d0e46b3186113a85";

export { CollisionQuery, hash };
